__turbopack_context__.v({
  "buttonContainer": "PlasmicRoundButton-module__XzgYRG__buttonContainer",
  "buttonContainersize_large": "PlasmicRoundButton-module__XzgYRG__buttonContainersize_large",
  "buttonContainersize_medium": "PlasmicRoundButton-module__XzgYRG__buttonContainersize_medium",
  "buttonContainersize_small": "PlasmicRoundButton-module__XzgYRG__buttonContainersize_small",
  "root": "PlasmicRoundButton-module__XzgYRG__root",
  "rootcolor_gray": "PlasmicRoundButton-module__XzgYRG__rootcolor_gray",
  "rootcolor_primary": "PlasmicRoundButton-module__XzgYRG__rootcolor_primary",
  "rootcolor_primary_isDisabled": "PlasmicRoundButton-module__XzgYRG__rootcolor_primary_isDisabled",
  "rootcolor_sky": "PlasmicRoundButton-module__XzgYRG__rootcolor_sky",
  "rootcolor_sky_isDisabled": "PlasmicRoundButton-module__XzgYRG__rootcolor_sky_isDisabled",
  "rootisDisabled": "PlasmicRoundButton-module__XzgYRG__rootisDisabled",
  "rootisDisabled_color_gray": "PlasmicRoundButton-module__XzgYRG__rootisDisabled_color_gray",
  "rootnotInteractable": "PlasmicRoundButton-module__XzgYRG__rootnotInteractable",
  "rootsize_large": "PlasmicRoundButton-module__XzgYRG__rootsize_large",
  "rootsize_medium": "PlasmicRoundButton-module__XzgYRG__rootsize_medium",
  "rootsize_small": "PlasmicRoundButton-module__XzgYRG__rootsize_small",
  "slotTargetIcon": "PlasmicRoundButton-module__XzgYRG__slotTargetIcon",
  "slotTargetIconcolor_gray": "PlasmicRoundButton-module__XzgYRG__slotTargetIconcolor_gray",
  "slotTargetIconcolor_sky": "PlasmicRoundButton-module__XzgYRG__slotTargetIconcolor_sky",
  "slotTargetIconcolor_sky_isDisabled": "PlasmicRoundButton-module__XzgYRG__slotTargetIconcolor_sky_isDisabled",
  "slotTargetIconisDisabled": "PlasmicRoundButton-module__XzgYRG__slotTargetIconisDisabled",
  "slotTargetIconisDisabled_color_gray": "PlasmicRoundButton-module__XzgYRG__slotTargetIconisDisabled_color_gray",
  "svg__pHGrg": "PlasmicRoundButton-module__XzgYRG__svg__pHGrg",
});
